/* EditNetworkDiscoveryAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");

class EditAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        activeView,
        userSession,
        NetworkDiscoveryPlan
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;
        this._selectedPlanIds = [];
        this._selectedPlanNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedPlanIds = this._activeView.getSelectedPlanIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPlanIds.length === 1) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    return this._activeView.pagingFeed.getNetworkDiscoveryEntityById(
                        this._selectedPlanIds[0]
                    );
                })
                .then((selectedPlan) => {
                    this._selectedPlan = selectedPlan;

                    this.launchNetworkDiscoveryEditor(
                        this._selectedPlan.getId(),
                        this._selectedPlan.getName()
                    );
                    // console.log("THIS PLAN WILL BE EDITED IN THE EDITOR", this._selectedPlan);
                })
                .catch((err) => {
                    this._logger.warn({error: err}, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({error: {errorMsg: err}});
                });
        } else {
            return Promise.resolve();
        }
    }

    launchNetworkDiscoveryEditor(id, name) {
        if (!id) {
            throw "Plan creation error, invalid plan id.";
        }
        let editorState = {
            fqn: Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name};
        return this._gameEditor.launchNetworkDiscoveryEditor(editorState, launchOpts);
    }
}

module.exports = EditAction;

EditAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
];

EditAction.$displayDetails = {
    type: "Action",
    name: "EditNetworkDiscovery",
    icon: "networkdiscovery.edit_network_discovery",
    shown: true,
    title: "Edit Discovery Plan",
    order: 3,
};
